import $ from 'jquery';

const $control = $('.global-help-button button');

$control.on('click', _handleFormControlHelp)

function _handleFormControlHelp(event) {
  var $container = $(event.target).parents('.form-group');

  if ($container.length !== 1) {
    // Do nothing
    return;
  }

  if ($container.hasClass('help-active')) {
    // Hide only the current
    $container.removeClass('help-active');
  } else {
    // Hide all
    $('.help-active').removeClass('help-active');
    // Show current
    $container.addClass('help-active');
  }
}
